import { Box, TypographyProps } from '@mui/material';
import ArticleList from './ArticleList';
import ArticleMeta from '../../types/ArticleMeta';
import { ArticleCardLocation } from '../../utilities/gtm';
import Pagination from '../Page/Pagination';
import NoResultsText from './NoResultsText';

interface ArticlesSectionProps {
  readonly articles: ArticleMeta[];
  readonly location: ArticleCardLocation;
  readonly headingLevel?: TypographyProps['component'];
  readonly totalArticleCount?: number;
  readonly showArticleAmount?: boolean;
  readonly hasNextPage?: boolean;
  readonly showOnlyCustomCoverImages?: boolean;
  readonly showGrid?: boolean;
  readonly hideCoverImages?: boolean;
  readonly emptyView?: React.ReactNode;
  fetchNextPage?: () => void;
}

export function ArticlesSection({
  articles,
  location,
  headingLevel,
  hasNextPage = false,
  fetchNextPage = () => {},
  totalArticleCount = 0,
  showArticleAmount = false,
  showOnlyCustomCoverImages = false,
  showGrid = false,
  hideCoverImages = false,
  emptyView = <NoResultsText />,
}: Readonly<ArticlesSectionProps>) {
  if (articles.length === 0) {
    return emptyView;
  }
  return (
    <>
      <ArticleList
        articles={articles}
        showGrid={showGrid}
        heading={headingLevel}
        showOnlyCustomCoverImages={showOnlyCustomCoverImages}
        hideCoverImages={hideCoverImages}
        location={location}
      />
      {showArticleAmount && (
        <Box sx={{ marginTop: 3 }}>
          <Pagination
            loadedArticleCount={articles.length}
            totalArticleCount={totalArticleCount}
            hasNextPage={hasNextPage}
            fetchNextPage={fetchNextPage}
          />
        </Box>
      )}
    </>
  );
}
